import * as React from "react";
import { userService } from "../../../Core/Api/services";
import { AclMapping } from "../../../Core/Api/Types/acl-mapping";
import { AclTypes } from "../../../Core/Api/Types/acl-types";
import { useMultipleSelection } from "../../../Utils/Hooks/useMultipleSelection";
import PermissionAccordionItem from "./PermissionAccordionItem/permission-accordion-item";

export interface PermissionAccordionListProps {
  searchValue: string;
  acls: AclTypes[];
  setAcls: React.Dispatch<React.SetStateAction<AclTypes[]>>;
}

const PermissionAccordionList: React.FC<PermissionAccordionListProps> = (props) => {
  const items = React.useMemo(() => ["Ingests", "Backoffice & Admin", "Workflow", "Orders"], []);
  const [aclMapping, setAclMapping] = React.useState<AclMapping[]>([]);
  const {
    select: expand,
    isSelected: isExpanded,
    selected: expanded,
    selectAll: expandAll,
  } = useMultipleSelection<string>([], items);

  React.useEffect(() => {
    userService.GetAclsMappingList().then(function (response) {
      if (response.aclsMapping) setAclMapping(response.aclsMapping);
    });
  }, []);

  const isGroupContainsSearch = (aclMapping: AclMapping, search): boolean => {
    if (search === "" || !search) return true;

    if (
      aclMapping.acls &&
      aclMapping.acls.filter((x) => x.label.includesAllWords(search) || x.value.toString().includesAllWords(search))
        .length > 0
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <ul>
      {aclMapping.map(
        (acl) =>
          acl.acls &&
          acl.acls.length > 0 &&
          isGroupContainsSearch(acl, props.searchValue) && (
            <PermissionAccordionItem
              key={acl.groupName}
              title={acl.groupName || ""}
              children={acl.acls || []}
              searchValue={props.searchValue}
              expanded={isExpanded(acl.groupName || "")}
              onClickExpand={() => expand(acl.groupName || "")}
              activeValues={props.acls}
              setAcls={props.setAcls}
            />
          )
      )}
    </ul>
  );
};

export default PermissionAccordionList;
